import dotPropImmutable from 'dot-prop-immutable';
export const documentTemplateSectionSlice = {
    createDocumentTemplateSection: (state, { payload: { section, templateId } })=>{
        const result = dotPropImmutable.merge(state, `${templateId}.template.templateContent.sections`, [
            section.documentSectionId
        ]);
        return dotPropImmutable.set(result, `${templateId}.sections.${section.documentSectionId}`, section);
    },
    updateDocumentTemplateContent: (state, { payload: { content, sectionId, templateId } })=>{
        return dotPropImmutable.set(state, `${templateId}.sections.${sectionId}.content`, content);
    }
};
